import { z } from "zod";
import { stamps, IsoDateTime, Uuid } from "./common.js";

/**
 * Append-only audit log entry — one per mutation, written in the same
 * transaction (`GET /api/audit`).
 */
export const AuditEntryDto = z.object({
  id: Uuid,
  /** When the mutation happened. */
  at: IsoDateTime,
  /** Null only for system-originated rows (e.g. migrations); normally set. */
  actorId: Uuid.nullable(),
  /** Denormalised actor display name, when joined. */
  actorName: z.string().nullable(),
  /** Action verb, e.g. "supplier.update", "price_list.publish". */
  action: z.string(),
  entityType: z.string(),
  entityId: z.string().nullable(),
  /** Entity snapshot before the mutation; null on creates. */
  before: z.record(z.string(), z.unknown()).nullable(),
  /** Entity snapshot after the mutation; null on deletes. */
  after: z.record(z.string(), z.unknown()).nullable(),
  ...stamps,
});
export type AuditEntry = z.infer<typeof AuditEntryDto>;
